var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors } from '@lean-body/components/styles';
import * as msg from '@lean-body/src/messages';
import { CCForm } from '@lean-body/components/molecules/cc_form';
import { Button, ButtonType } from '../atoms';
import { useNavigate } from 'react-router-dom';
import { routes } from '@lean-body/src/route';
import { SettingItemKeys } from './setting_menu';
import { PageLoading } from './page_loading';
import { CC3DSAuthentication } from './cc_3ds_auth';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
export const CCChangeSubsection = ({ classObject, accountService, apiClient, alertPresenter, config, me, setMe, }) => {
    var _a, _b;
    const canChangeCreditCard = !!me.canChangeCreditCard;
    const navigate = useNavigate();
    const [stripePromise] = useState(() => loadStripe(config.stripeAPIKey));
    const [isRequiresAction, setIsRequiresAction] = useState(false);
    const [transactionID, setTransactionID] = useState(Math.random().toString());
    const [clientSecret, setClientSecret] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [disableCCForm, setDisableCCForm] = useState(false);
    const [invoiceFailed, setInvoiceFailed] = useState(me.invoiceFailed);
    useEffect(() => {
        apiClient
            .fetchFailedPaymentIntent()
            .then((v) => {
            if (v) {
                setIsRequiresAction(v.isRequiresAction);
                setClientSecret(v.clientSecret);
            }
        })
            .finally(() => {
            setIsLoading(false);
        });
    }, [transactionID]);
    const canceleUnsubscribeSchedule = () => {
        navigate(`${routes.SETTING.compile()}?key=${SettingItemKeys.plan}`);
    };
    const handleAfterAuthentication = (isSuccess) => {
        if (isSuccess) {
            // 決済成功の webhook の完了に間に合わず、me.invoiceFailed が更新されない可能性があるので me の再取得はここでは行わない
            setInvoiceFailed(false);
        }
        setTransactionID(Math.random().toString());
    };
    const createSetupIntent = () => __awaiter(void 0, void 0, void 0, function* () {
        return apiClient.createSetupIntentByCustomer();
    });
    const onSubmit = (paymentMethodID) => __awaiter(void 0, void 0, void 0, function* () {
        setDisableCCForm(true);
        return apiClient
            .changePaymentSource({ paymentMethodID: paymentMethodID })
            .then(() => {
            accountService.fetchMe({ nocache: true }).then((me) => {
                setMe(me);
                setDisableCCForm(false);
                alertPresenter.showMessage(msg.CC_CHANGE_SUCCEEDED, 'cc_change_result');
            });
        })
            .catch((err) => {
            setDisableCCForm(false);
            alertPresenter.showError(err, msg.CC_CHANGE_FAILED, 'cc_change_result');
        });
    });
    if (isLoading) {
        return React.createElement(PageLoading, null);
    }
    return (React.createElement("div", { className: css(styles.container, classObject), id: 'change_cc' }, canChangeCreditCard ? (React.createElement(React.Fragment, null, isRequiresAction ? (React.createElement(Elements, { stripe: stripePromise },
        React.createElement(CC3DSAuthentication, { alertPresenter: alertPresenter, clientSecret: clientSecret, curCCLastFour: (_a = me.payment) === null || _a === void 0 ? void 0 : _a.cardLastFour, handleAfterAuthentication: handleAfterAuthentication }))) : (React.createElement(React.Fragment, null,
        invoiceFailed && (React.createElement("div", { className: css(styles.messageInvoiceFailed) },
            "\u5229\u7528\u6599\u306E\u652F\u6255\u3044\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
            React.createElement("br", null),
            "\u304A\u624B\u6570\u3067\u3059\u304C\u3001\u6709\u52B9\u306A\u304A\u652F\u6255\u3044\u60C5\u5831\u3078\u306E\u5909\u66F4\u3092\u304A\u9858\u3044\u3044\u305F\u3057\u307E\u3059\u3002",
            React.createElement("br", null),
            "1\u30F6\u6708\u4EE5\u5185\u306B\u6709\u52B9\u306A\u304A\u652F\u6255\u3044\u60C5\u5831\u3078\u306E\u5909\u66F4\u304C\u306A\u3044\u5834\u5408\u306F\u9000\u4F1A\u6271\u3044\u3068\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002",
            React.createElement("br", null))),
        React.createElement("div", { className: css(styles.currentCC) },
            React.createElement("div", { className: css(styles.currentCCLabel) }, "\u73FE\u5728\u306E\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9"),
            React.createElement("div", null, `**** **** **** ${(_b = me.payment) === null || _b === void 0 ? void 0 : _b.cardLastFour}`)),
        React.createElement(CCForm, { alertPresenter: alertPresenter, submitLabel: "\u5909\u66F4", config: config, createSetupIntent: createSetupIntent, onSubmit: onSubmit, disableCCForm: disableCCForm }))))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css(styles.messageForDeleted) }, "\u9000\u4F1A\u4E2D\u306E\u305F\u3081\u304A\u652F\u6255\u3044\u65B9\u6CD5\u306E\u5909\u66F4\u3092\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u305B\u3093\u3002"),
        React.createElement(Button, { buttonType: ButtonType.primary, onClick: canceleUnsubscribeSchedule, fullWidth: true }, "\u9000\u4F1A\u3092\u53D6\u308A\u6D88\u3059")))));
};
const styles = StyleSheet.create({
    container: {},
    currentCC: {
        marginBottom: 8,
        textAlign: 'center',
    },
    currentCCLabel: {
        marginBottom: 4,
        fontSize: 14,
        color: Colors.GrayDarkest,
    },
    messageForDeleted: {
        fontSize: 14,
        textAlign: 'center',
        marginBottom: 24,
    },
    messageInvoiceFailed: {
        color: Colors.Red,
        fontSize: 14,
        textAlign: 'center',
        marginBottom: 24,
    },
});
